import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import TStore from '../../../../types/store';
import VitalItem from './vital-item';
import VitalItemEmpty from './vital-item-empty';
import HistoryDrawer from '../history-drawer';
import getVitalEntryList from '../../../../helpers/vital-list-helper';
import { HistoryDrawerData, IVitalListEntry } from '../../../../types/life-id';

type Props = ReturnType<typeof mapStateToProps>;

const VitalList: React.FC<Props> = ({ vitalListSettings, vitalData }) => {
  const [drawer, setDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<HistoryDrawerData>({ type: 'HR' });

  const vitalListData = useMemo(() => {
    return getVitalEntryList(vitalData, vitalListSettings);
  }, [vitalData, vitalListSettings]);

  const List = useMemo(() => {
    return vitalListData.map((vitalListEntry, i) => {
      if (vitalListEntry.isEmpty) {
        const { iconSrc, title } = vitalListEntry;
        return <VitalItemEmpty key={i} iconSrc={iconSrc} title={title} />;
      } else {
        return (
          <VitalItem
            key={i}
            vitalListEntry={vitalListEntry as IVitalListEntry}
            onDetailOpen={() => {
              setDrawerData({
                type: (vitalListEntry as IVitalListEntry).modalType,
                args: { vitalListEntry: vitalListEntry as IVitalListEntry },
              });
              setDrawer(true);
            }}
          />
        );
      }
    });
  }, [vitalListData]);

  return (
    <>
      {List}
      <HistoryDrawer visible={drawer} drawerData={drawerData} onClose={() => setDrawer(false)} />
    </>
  );
};

const mapStateToProps = (store: TStore) => ({
  vitalData: store.lifeId.vitalData,
  vitalListSettings: store.lifeId.vitalListDataSettings,
});

export default connect(mapStateToProps)(VitalList);
